import { Link, Outlet, useParams, useLocation } from "react-router-dom";
import "../../styles/pages/interview/_hub-tab.scss";

export default function QuestionsLayout() {
    const { qid } = useParams();
    const location = useLocation();
    const isDetail = Boolean(qid);
    const isRecordingDetail = location.pathname.includes("/recording/");

    return (
        <div className="q-shell">
            {/* Only show the breadcrumb trail when drilling into a question detail */}
            {isDetail && !isRecordingDetail && (
                <div className="q-shell__breadcrumb-wrap">
                    <nav
                        className="q-shell__breadcrumb"
                        aria-label="Breadcrumb"
                    >
                        <Link
                            to="/dashboard/questions"
                            className="q-shell__breadcrumb-back"
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                aria-hidden="true"
                            >
                                <path
                                    d="M10 3L5 8l5 5"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            Question bank
                        </Link>
                        <span
                            className="q-shell__breadcrumb-sep"
                            aria-hidden="true"
                        >
                            /
                        </span>
                        <span
                            className="q-shell__breadcrumb-current"
                            aria-current="page"
                        >
                            Selected question
                        </span>
                    </nav>
                </div>
            )}

            {/* The child route renders its own full heading — no duplicate title here */}
            <Outlet />
        </div>
    );
}
